import { action } from "satcheljs";
import type { AddAccountDialogProps } from "../types/AddAccountDialogProps";
import type { AccountOriginContext } from "owa-account-storage-types";
import type { AddAccountLaunchMode, PrioritizedAccountDataWithError, } from "owa-account-config-types";
import type { AccountConfigDialogLaunchOrigin } from "owa-account-config-shared";

/*
 * Dispatch this action to render the account configuration experience
 */
export interface ShowAccountConfigurationDialogInMainWindowActionMessage {
    dialogTrigger: AccountConfigDialogLaunchOrigin;
    targetWindow?: Window | undefined;
    fallbackData?: PrioritizedAccountDataWithError | undefined;
    originContext?: AccountOriginContext | undefined;
    launchMode?: AddAccountLaunchMode | undefined;
    onCloseDialog?: (() => void) | undefined;
}
export const showAccountConfigurationDialog: (props: AddAccountDialogProps) => ShowAccountConfigurationDialogInMainWindowActionMessage = action("showAccountConfigurationDialogInMainWindow", (props: AddAccountDialogProps): ShowAccountConfigurationDialogInMainWindowActionMessage => ({
    ...props,
}));

/*
 * Dispatch this action to render the account configuration experience
 * in a projection window, such as Settings
 */
export interface ShowAccountConfigurationDialogInPopoutActionMessage {
    dialogTrigger: AccountConfigDialogLaunchOrigin;
    targetWindow?: Window | undefined;
    fallbackData?: PrioritizedAccountDataWithError | undefined;
    originContext?: AccountOriginContext | undefined;
    launchMode?: AddAccountLaunchMode | undefined;
    onCloseDialog?: (() => void) | undefined;
}
export const showAccountConfigurationDialogInProjection: (props: AddAccountDialogProps) => ShowAccountConfigurationDialogInPopoutActionMessage = action("showAccountConfigurationDialogInPopout", (props: AddAccountDialogProps): ShowAccountConfigurationDialogInPopoutActionMessage => ({
    ...props,
}));
